<script>
    export default {
        computed: {
            isLoad() { return this.$store.getters.IS_LOAD },
        }
    }
</script>


<template>
    <div 
        class="loader_screen"
        v-if="isLoad"
    >
        <div class="loader_component"></div>
    </div>    
</template>


<style scoped>
    .loader_screen {
        position: fixed;
        z-index: 1000;

        width: 100%;
        height: 100%;

        background-color: #00000030;
    }

    @keyframes rotate {
        from {
            transform: rotate(0deg);
        }
        to { 
            transform: rotate(360deg);
        }
    }

    .loader_component {
        position: fixed;
        z-index: 1001;

        width: 50px;
        height: 50px;
        left: 60px;
        bottom: 50px;

        border: solid 8px #ffffff;
        border-radius: 50%;
        border-right-color: transparent;
        border-bottom-color: transparent;
        
        transition: all 0.5s ease-in;
        animation-name: rotate; 
        animation-duration: 1.0s; 
        animation-iteration-count: infinite;
        animation-timing-function: linear; 
    }
</style>